/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, {useState} from "react";
import {text} from "../utils/i18n";
import {Button} from "../components/controls";
import {AddressSection} from "../../ecomm/containers/address-section";
import {Checkbox} from "../components/fields";
import {useCustomerState} from "../contexts/customer";
import {DoterraReactSelect} from "../components/doterra-react-select";
import {flushSync} from "react-dom";

const leftCenter = {
  paddingLeft: "0"
};

export const PaymentAddressPanel = (props) => {
  const {mode, addresses, regions, setForm, payment, market, useSavedAddress, cartShippingAddress, getCurrentFieldValues} = props;
  const [addressChange, setAddressChange] = useState(payment && payment.billingAddress ? payment.billingAddress.id : addresses.length > 0 ? addresses[0].id : "");
  const [newBillingAddress, setBillingAddress] = useState(true);
  let {orderType = "FIRSTTIME"} = useCustomerState();

  let displayAddressInit;
  if(cartShippingAddress) {
    displayAddressInit = {
      line1: cartShippingAddress.line1,
      town: cartShippingAddress.town,
      regionCode: cartShippingAddress.region.isocodeShort,
      postalCode: cartShippingAddress.postalCode,
      countryName: cartShippingAddress.country.isocode === 'CA' ? 'Canada' : 'United States'
    };
  }
  const [displayAddress, setDisplayAddress] = useState(displayAddressInit);

  const handleShowNewBillingAddress = (e) => {
    flushSync(() => {
      setBillingAddress(!!(e !== undefined && e.target.checked));
    });
  };

  const handleSavedBillingAddressChange = (selectedAddressId) => {
    flushSync(() => {
      setAddressChange(selectedAddressId);
    });
    let newChosenAddress = addresses.find(e => {
      return e.id === selectedAddressId;
    });

    setForm("billingLine1", newChosenAddress.line1);
    setForm("billingLine2", newChosenAddress.line2);
    setForm("billingCity", newChosenAddress.town);
    setForm("billingState", newChosenAddress.region.isocodeShort);
    setForm("billingZip", newChosenAddress.postalCode);
  };

  const handleHideNewBillingAddress = () => {
    flushSync(() => {
      setBillingAddress(true);
    });
    const newBillingAddress = getCurrentFieldValues();
    if(newBillingAddress) {
      let newDisplayAddress = {
        line1: newBillingAddress.billingLine1,
        town: newBillingAddress.billingCity,
        regionCode: newBillingAddress.billingState,
        postalCode: newBillingAddress.billingZip,
        countryName: newBillingAddress.market === 'CA' ? 'Canada' : 'United States'
      };
      flushSync(() => {
        setDisplayAddress(newDisplayAddress);
      });
    }
  };
  if((addresses === undefined || addresses.length === 0) && newBillingAddress !== false) {
    handleShowNewBillingAddress();
  }

  if(orderType === "FIRSTTIME") {
    return (
      <>
        <div className="form-group">
          <div className="control-group">
            <label htmlFor="savedAddresses"
                   className="dropdown-label">{text("paymentMethod.billingAddress.header")}</label>
          </div>
        </div>
        <Checkbox id={"createNewAddress"} defaultChecked={true}
                  labelKey={"form.paymentManagement.useShippingAddress"} classes="form-control"
                  labelClasses="form.paymentManagement.useShippingAddress" onChange={e => {
          handleShowNewBillingAddress(e);
        }} cssStyles={leftCenter}/>
        {newBillingAddress ? displayAddress && <div id="new-card-default-address">
          {displayAddress.line1}<br/>{displayAddress.town}, {displayAddress.regionCode}&nbsp;{displayAddress.postalCode}<br/>{displayAddress.countryName}<br/><br/>
        </div>
          : <AddressSection mode={mode} hideSection={handleHideNewBillingAddress} market={market} regions={regions} useSavedAddress={useSavedAddress}/>
        }
      </>
    );
  }

  let deliveryAddressOptions = (addresses|| []).map((address) =>{return {value: address.id, label: address.addressBookNickname};});

  return (
    <>
      <div className="form-group">
        <div className="control-group">
          <label htmlFor="savedAddresses" className="dropdown-label">{text("paymentMethod.billingAddress.header")}</label>
          <DoterraReactSelect options={deliveryAddressOptions} value={addressChange} onChange={handleSavedBillingAddressChange} />
{/*          <select id="savedAddresses" value={addressChange} className="form-control doterra-select" onChange={e => {
            handleSavedBillingAddressChange(e.target.value);
          }}>
            {(addresses || []).map((address, index) => <option key={index} value={address.id}>{address.addressBookNickname}</option>)}
          </select>*/}
        </div>
      </div>
      {newBillingAddress ?
        <Button id={"createNewAddress"} disabled={false} text={text("form.paymentManagement.addNewBillingAddress")} classes={"btn btn-link"}
                onClick={handleShowNewBillingAddress} cssStyles={leftCenter}/>
        : <AddressSection mode={mode} hideSection={handleHideNewBillingAddress} market={market} regions={regions} useSavedAddress={useSavedAddress}/>
      }
    </>
  );
};
